import { useState, useMemo } from "react";

const useImageThumbnail = ({ isLoading, thumb }) => {
    const [loaded, setLoaded] = useState(false);
    const error = useMemo(() => {
        // Error is always when the thumbnail failed to load
        return !loaded
    }, [loaded])

    const mediaIsProcessing = useMemo(() => {
        // media is processing when it is being encoded in the background
        // and the server's image URL is not yet available
        return ((!thumb || error) && !isLoading) || (thumb || '').startsWith('data')
    }, [thumb, error, isLoading])


    return {
        errorState: [error],
        loadedState: [loaded, setLoaded],
        mediaIsProcessing,
    }
};

export default useImageThumbnail;
